import styled from 'styled-components';

export const InvestmentAllocationCardStyles = styled.div`
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	padding: 1rem;
	transition: border-color 0.2s ease;

	&:hover {
		border-color: ${({ theme }) => theme.v3.colors.blue[4]};
	}

	.settings-btn {
		display: flex;
		align-items: center;
		border-radius: 0.25rem;
		padding: 0.25rem;
		transition: background 0.2s ease;
		cursor: pointer;

		&:hover {
			background: ${({ theme }) => theme.v3.colors.gray[2]};
		}
	}
`;
